import React, { Component } from "react";
import {
  Button,
  TextField,
  DialogContainer,
  SelectField,
  CircularProgress,
  FontIcon,
} from "react-md";
import { countries, states } from "../../../common/utils";
import { isBoolean, omit } from "lodash";
const members = [
  { label: "", value: "" },
  { label: "Member", value: true },
  { label: "Non Member", value: false },
];

const membershipTypes = [
  "",
  "Basic Membership",
  "Premium Membership",
  "Ultimate Membership",
  "Junior Membership",
  "Boomer Membership",
  "Instructor Membership",
];

const countriesFilter = ["", ...countries];
const statesFilter = [{ label: "", value: "" }, ...states];
export default class ExportCsvButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogVisible: false,
      advanceDialogVisible: false,
      country: "",
      state: "",
      isMember: "",
      membershipType: "",
    };

    this.handleExport = this.handleExport.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.closeAdvanceExportDialog = this.closeAdvanceExportDialog.bind(this);
    this.openAdvanceFilterDialog = this.openAdvanceFilterDialog.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  openAdvanceFilterDialog() {
    this.setState(() => ({
      advanceDialogVisible: true,
      country: "",
      state: "",
      isMember: "",
      membershipType: "",
    }));
  }

  closeAdvanceExportDialog() {
    this.setState(() => ({
      advanceDialogVisible: false,
      country: "",
      state: "",
      isMember: "",
      membershipType: "",
    }));
  }

  handleFilterChange(field, value) {
    this.setState(() => ({
      [field]: value,
    }));
  }

  handleExport() {
    const filters = {
      ...omit(this.state, ["dialogVisible", "advanceDialogVisible"]),
    };
    this.setState(() => ({
      dialogVisible: true,
      advanceDialogVisible: false,
      country: "",
      state: "",
      isMember: "",
      membershipType: "",
    }));

    const { locations } = this.props;

    this.props.onExport(filters, locations);
  }

  closeDialog() {
    this.setState(() => ({
      dialogVisible: false,
    }));
  }

  render() {
    const { style, exporting } = this.props;
    const actions = [];
    actions.push({
      secondary: true,
      children: "Cancel",
      onClick: this.closeAdvanceExportDialog,
    });
    actions.push(
      <Button flat primary onClick={this.handleExport}>
        Export Customers
      </Button>
    );

    return (
      <div style={style}>
        <Button
          flat
          secondary
          iconBefore={false}
          onClick={this.openAdvanceFilterDialog}
        >
          Export <FontIcon>launch</FontIcon>
        </Button>
        <DialogContainer
          id="filter-action-dialog"
          visible={this.state.advanceDialogVisible}
          onHide={this.closeAdvanceExportDialog}
          actions={actions}
          height={460}
          width={500}
          title="Advance Filters"
        >
          <SelectField
            id="country"
            label="Filter by country"
            className="md-cell md-cell--12"
            menuItems={countriesFilter}
            onChange={(value) => this.handleFilterChange("country", value)}
          />
          <SelectField
            id="state"
            label="Filter by state"
            className="md-cell md-cell--12"
            menuItems={statesFilter}
            onChange={(value) => this.handleFilterChange("state", value)}
          />
          <SelectField
            id="is-member"
            label="Member or Non member"
            className="md-cell md-cell--12"
            menuItems={members}
            onChange={(value) => this.handleFilterChange("isMember", value)}
          />
          <SelectField
            id="membership-type"
            label="Filter by membership type"
            className="md-cell md-cell--12"
            menuItems={membershipTypes}
            onChange={(value) =>
              this.handleFilterChange("membershipType", value)
            }
          />
        </DialogContainer>
        <DialogContainer
          id="confirmDialog"
          aria-labelledby="confirmDialog"
          title="Export Customer"
          visible={this.state.dialogVisible}
          onHide={this.closeDialog}
          modal
          dialogStyle={{ width: 390 }}
          actions={[
            {
              onClick: this.closeDialog,
              label: "Close",
            },
          ]}
        >
          {exporting === false ? (
            <div>Export complete.</div>
          ) : (
            <div>
              <CircularProgress key="export-progress" id="export-progress" />
              Export is in progress...
            </div>
          )}
        </DialogContainer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/customer/components/ExportCsvButton/ExportCsvButton.jsx